<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss" rel="stylesheet/scss">
  @import "assets/css/style.scss";
  @import "assets/css/subject.scss";
  @import "assets/iconfont.css";
  #app {
    height: 100%;
  }
  .text-tip{
    line-height: 30px;
    font-size: 0.8rem;
    color: #7B7B7B;
    text-align: center;
  }
  .row-flex, .row-flex-around, .row-flex-between, .row-flex-start, .row-flex-end {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
  .row-flex {
    justify-content: center;
  }
  .row-flex-around {
    justify-content: space-around;
  }
  .row-flex-between {
    justify-content: space-between;
  }
  .row-flex-start {
    justify-content: flex-start;
  }
  .row-flex-end {
    justify-content: flex-end;
  }
  .column-flex, .column-flex-between{
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .column-flex{
    justify-content: center;
  }
  .column-flex-between{
    justify-content: space-between;
    align-items: flex-start;
  }
  .wrap-flex{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: row;
  }
  /*文字展示一行*/
  .text-hide{
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  /*课程卡片布局样式*/
  .card {
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.16);
    border-radius: 4px;
    margin-bottom: 16px;
    position: relative;
    color: #666666;
    cursor: pointer;
    background-color: #ffffff;
    .card-image {
      width: 100%;
      border-radius: 4px 4px 0 0;
      position: relative;
      padding-top: 56%;
      height: 0;
      overflow: hidden;
      cursor: pointer;
    }
    .card-image-left {
      border-radius: 4px;
      width: 32%;
      position: relative;
      padding-top: 18%;
    }
    .card-image img, .card-image-left img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .card-checkbox {
      position: absolute;
      top: 4%;
      right: 6%;
    }
    .card-bottom {
      padding: 8px 12px;
      font-size: 12px;
      line-height: 20px;
    }
    .card-title {
      font-size: 16px;
      color: #000000;
      line-height: 15px;
      padding-bottom: 12px;
    }
    .card-icon {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
    .card-position {
      position: absolute;
      background-color: rgba(255,255,255, 0.6);
      border-radius: 20px;
      padding: 4px 12px;
      top: 3%;
      right: 3%;
      z-index: 1;
    }
  }
  .card-type {
    padding: 4px 10px;
    background: #fff5f0;
    border-radius: 8px;
    color: #f88600;
    text-align: center;
    margin: 0 6px 6px 0;
    font-size: 12px;
    width: auto;
    display: inline-block;
    line-height: 18px;
  }
  .title-select{
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 3px solid #0177FB;
    display: inline-block;
    cursor: pointer;
  }
  .title-unselect{
    font-size: 15px;
    padding-bottom: 13px;
    display: inline-block;
    cursor: pointer;
  }
  .like-icon{
    width: 20px;
    height: 20px;
    margin-right: 10px;
    cursor: pointer;
  }
  .classLayout{
    font-size: 16px;
    margin: 0 0 20px 0;
    padding: 20px 30px;
    border-radius: 10px;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.16);
    color: #333333;
    overflow: hidden;
    .classLayout-left{
      color: rgba(174,183,200);
      margin-right: 40px;
    }
    .classLayout-hr{
      width: calc(100% - 90px);
      height: 1px;
      margin: 15px 0 15px 90px;
      background-color: #E2ECFB;
    }
  }
  .shadow-layout{
    background-color: #eeeeee;
    border-radius: 5px;
    padding: 10px 16px;
    margin: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue